module.exports = __webpack_public_path__ + "img/left.9eeaf2f6.png";